module.exports = __webpack_public_path__ + "static/media/clem-onojegaw.c058841b.jpg";